// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCompanyByExternalIdAsyncRequestModel from '../../model/get-company-by-external-id-async-request-model';
import GetCompanyByExternalIdAsyncRequestDTO from '../dto/get-company-by-external-id-async-request-dto';
import dtoSchema from '../schemas/get-company-by-external-id-async-request-schema';

export default abstract class GetCompanyByExternalIdAsyncRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCompanyByExternalIdAsyncRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<GetCompanyByExternalIdAsyncRequestDTO>): GetCompanyByExternalIdAsyncRequestModel;
  static toModel(dto: DeepPartial<GetCompanyByExternalIdAsyncRequestDTO> | undefined | null): GetCompanyByExternalIdAsyncRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCompanyByExternalIdAsyncRequestDTO> | undefined | null): GetCompanyByExternalIdAsyncRequestModel | undefined {
    return dto ? new GetCompanyByExternalIdAsyncRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCompanyByExternalIdAsyncRequestModel> | GetCompanyByExternalIdAsyncRequestModel): GetCompanyByExternalIdAsyncRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as GetCompanyByExternalIdAsyncRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCompanyByExternalIdAsyncRequestModel, can not map to GetCompanyByExternalIdAsyncRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
